import axios from 'axios';

export default {
  get(url) {
    return axios.get(url, {
      headers: getSimpleHeaders(),
    });
  },

  post(url, body) {
    return axios.post(url, body, {
      headers: getSimpleHeaders(),
    });
  },

  put(url, body) {
    return axios.put(url, body, {
      headers: getSimpleHeaders(),
    });
  },

  delete(url) {
    return axios.delete(url, {
      headers: getSimpleHeaders(),
    });
  },

  patch(url, body) {
    return axios.patch(url, body, {
      headers: getSimpleHeaders(),
    });
  },

  postWithUpload(url, body) {
    return axios.post(url, body, {
      headers: getUploadHeaders(),
    });
  },

  getFromFile(url) {
    return axios.get(url, {
      responseType: 'blob',
    });
  },
};

function getSimpleHeaders() {
  return {
    'Content-Type': 'application/json',
  };
}

function getUploadHeaders() {
  return {
    'Content-Type': 'application/json, multipart/form-data',
  };
}
